/* ==========================================================================
   Siraat — country selector, built on open

   snippets/localization-selector.liquid ships the ~231 country buttons inside a
   <template>, so the browser parses them into a DocumentFragment rather than the
   live document. No elements in the DOM tree, no style recalculation, no layout.
   They were the largest single contributor to the page's 2,882-node DOM and the
   popover is opened by a small minority of visitors.

   This moves them into the list on the first interaction with the trigger, in
   the capture phase, so they are in place before the theme opens the popover.
   The buttons are real <button type="submit" name="country_code"> inside the
   existing localization form, so once moved they submit natively exactly as
   they did when they were rendered inline.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__siraatLocalizationDeferred) return;
  window.__siraatLocalizationDeferred = true;

  function hydrate(list) {
    if (!list || list.getAttribute('data-localization-deferred') !== 'pending') return;
    var tpl = list.querySelector('template[data-localization-options]');
    if (!tpl || !tpl.content) return;
    list.setAttribute('data-localization-deferred', 'done');
    list.appendChild(tpl.content.cloneNode(true));
    if (tpl.parentNode) tpl.parentNode.removeChild(tpl);
  }

  function hydrateWithin(root) {
    if (!root || !root.querySelectorAll) return;
    var lists = root.querySelectorAll('[data-localization-deferred="pending"]');
    for (var i = 0; i < lists.length; i++) hydrate(lists[i]);
  }

  function onInteraction(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var trigger = target.closest('[aria-controls]');
    if (!trigger) return;
    var id = trigger.getAttribute('aria-controls');
    if (!id || id.indexOf('popover-localization-') !== 0) return;
    hydrateWithin(document.getElementById(id));
  }

  /* Capture phase on the document, so this runs ahead of whatever handler the
     theme has on the button itself, whichever way the popover is reached:
     tap, mouse, keyboard or focus. */
  var events = ['pointerdown', 'touchstart', 'keydown', 'focusin', 'click'];
  for (var i = 0; i < events.length; i++) {
    document.addEventListener(events[i], onInteraction, true);
  }

  /* Hover, bound directly to the triggers rather than delegated.
     theme.js DialogElement opens on click always, and on 'pointerenter' when the
     trigger carries data-open-on-hover. The localization trigger does not carry
     it today, so click is the only way in and the listeners above are enough.
     But the header already uses hover to open its menus, so if that attribute is
     ever added here the popover would open before anything above had fired, and
     it would open empty.

     A delegated 'pointerover' on the document would cover that, at the cost of a
     closest() walk on every mouse move across the page. There are exactly two of
     these triggers, so binding them directly is both cheaper and precise. */
  function bindTriggers(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var triggers = root.querySelectorAll('[aria-controls^="popover-localization-"]');
    for (var i = 0; i < triggers.length; i++) {
      var trigger = triggers[i];
      if (trigger.getAttribute('data-localization-bound') === 'true') continue;
      trigger.setAttribute('data-localization-bound', 'true');
      trigger.addEventListener('pointerenter', onInteraction);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindTriggers(); }, { once: true });
  } else {
    bindTriggers();
  }

  /* Theme editor: a re-rendered section brings new, unbound triggers. */
  document.addEventListener('shopify:section:load', function (e) { bindTriggers(e.target); });
})();
